import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { api, tokenStore } from "../lib/api";
import logger from "../lib/logger";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = unauth, object = auth
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        const t = tokenStore.get();
        if (!t) {
            if (mounted) {
                setUser(false);
                setLoading(false);
            }
            return;
        }
        api.get("/auth/me")
            .then((r) => mounted && setUser(r.data))
            .catch(() => {
                tokenStore.clear();
                if (mounted) setUser(false);
            })
            .finally(() => mounted && setLoading(false));
        return () => {
            mounted = false;
        };
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        if (data.access_token) tokenStore.set(data.access_token);
        setUser(data);
        return data;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (err) {
            // Logout best-effort; server may already be unreachable
            logger.warn("Logout API call failed:", err?.message || err);
        }
        tokenStore.clear();
        setUser(false);
    };

    const value = useMemo(() => ({ user, loading, login, logout }), [user, loading]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    return useContext(AuthContext);
}
